import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import styles from './inhouseRequest.module.scss'
import { ButtonComponent, CheckBoxComponent, RadioButtonComponent } from '@syncfusion/ej2-react-buttons'
import { useParams } from 'react-router'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../redux/_reduxHooks.tsx'
import { BookedResponse, fetchWebEventDataFromApi } from '../redux/bookingSlice.tsx'
import { protectedResources } from '../configs/protectedApis.ts'
import { WebThemaDto } from '../types/webTypes/WebThemaDto.tsx'
import {
  ChangeEventArgs,
  Count,
  FormatPainter,
  HtmlEditor,
  Image,
  Inject,
  Link,
  PasteCleanup,
  QuickToolbar,
  RichTextEditorComponent,
  Table,
  Toolbar,
  ToolbarSettingsModel,
  ToolbarType,
} from '@syncfusion/ej2-react-richtexteditor'
import DOMPurify from 'dompurify'
import callApi from '../services/callApi.tsx'
import Redirect from '../services/Redirect.tsx'
import { DialogUtility, showSpinner } from '@syncfusion/ej2-react-popups'
import * as Sentry from '@sentry/react'

type TokenTyp = {
  accessToken: string,
  hashPassword: string,
}

const InhouseRequest = () => {
  const { topicId } = useParams()
  const dispatch = useAppDispatch()
  const topic = useAppSelector((state) => state.booking.webTopic)
  const inhouseRequest = useForm<requestFormData>({
    defaultValues: {
      anfrageDatum: new Date(),
    },
  })
  const {
    watch,
    getValues,
    setValue,
    control,
    register,
    reset,
    handleSubmit,
    trigger,
    formState: { errors },
  } = inhouseRequest
  const [cleanHtmlContent, setCleanHtmlContent] = useState('')
  const onSubmit: SubmitHandler<requestFormData> = (data) => {
    // Hier würden Sie mit den Daten verfahren, z.B. an einen Server senden
    const html = document.getElementById('mainTarget')
    if (html) {
      showSpinner(html)
    }
    const postUrl = protectedResources.apiList.postInhouseReq
    callApi({ url: postUrl, method: 'POST', bodyData: data, responseType: 'json' }).then((resp) => {
      if (resp.status === 200) {
        Redirect('../erfolg')
      }
    })
  }

  const items: string[] = [
    'Bold',
    'Italic',
    'Underline',
    '|',
    'FontName',
    'FontSize',
    'FontColor',
    'BackgroundColor',
    '|',
    'Formats',
    'Alignments',
    '|',
    'NumberFormatList',
    'BulletFormatList',
    '|',
    'Outdent',
    'Indent',
    '|',
    'CreateTable',
    '|',
    'Undo',
    'Redo',
  ]

  const toolbarSettings: ToolbarSettingsModel = {
    items: items,
    type: ToolbarType.MultiRow,
    enableFloating: false,
  }

  useEffect(() => {
    if (topicId) {
      const eventUrl = `${protectedResources.apiList.readWebEvent}?thmcode=${topicId}`
      dispatch(fetchWebEventDataFromApi({ url: eventUrl, method: 'GET', responseType: 'json' })).then((resp) => {
        if (resp.meta.requestStatus === 'fulfilled') {
          const data = resp.payload as BookedResponse
          if (data.data) {
            const topicData = data.data as WebThemaDto
            const currentValues = getValues()
            reset({
              ...currentValues,
              anfrageDatum: new Date(),
              themenwunsch: `${topicData.thmCode} - ${topicData.thmLang}`,
              seminarDauer: `${topicData.thmDauer}`,
              teilnahmeForm: 1,
              thematischeSchwerpunkte: '',
              topicId: topicData.id,
            })
            if (topicData.thmTypValue === 'Online') {
              setValue('teilnahmeForm', 0)
            }
          }
        }
      })
    }
  }, [topicId])

  const handleChange = (value: 'online' | 'praesenz') => {
    setValue('teilnahmeForm', value === 'online' ? 0 : 1)
  }

  useEffect(() => {
    if (topic?.schwerpunkte) {
      const cleanHtmlContent = DOMPurify.sanitize(topic?.schwerpunkte)
      setCleanHtmlContent(cleanHtmlContent)
      setValue('semiSchwerpunkte', cleanHtmlContent)
    }
  }, [topic?.schwerpunkte])

  const radio = watch('plannedParticipants')

  useEffect(() => {
    switch (radio) {
      case 0:
        setValue('teilnehmeranzahl', '5-10')
        break
      case 1:
        setValue('teilnehmeranzahl', '11-15')
        break
      case 2:
        setValue('teilnehmeranzahl', '16-20')
        break
      case 3:
        setValue('teilnehmeranzahl', '21-25')
        break
      case 4:
        setValue('teilnehmeranzahl', '')
        break
    }
  }, [radio])

  let dialogObj: any
  const buttonClick = async () => {
    const result = await trigger()
    if (result) {
      dialogObj = DialogUtility.confirm({
        title: 'Preisinformation',
        content: 'Bei einer Preisinformation werden Ihre Bemerkungen nicht berücksichtig. Eine Anpassung der Inhalte ist in diesem Fall nicht möglich.',
        width: '600px',
        okButton: { text: 'Fortfahren', click: confirmOkAction.bind(this) },
        cancelButton: { text: 'Abbrechen', click: confirmCancelAction.bind(this) },
      })
    }
  }
  const confirmOkAction = () => {
    dialogObj.hide()

    const html = document.getElementById('mainTarget')
    if (html && !import.meta.env.DEV) {
      showSpinner(html)
    }

    callApi({
      url: import.meta.env.VITE_API_URL + '/Token/ReadClientKey/client',
      token: '',
      method: 'GET',
      responseType: 'json',
    }).then((res) => {
      const tokenData = res.data as TokenTyp
      const data = getValues()
      const postUrl = protectedResources.apiList.postInhouseQuote
      callApi({
        url: postUrl,
        method: 'POST',
        bodyData: data,
        responseType: 'json',
        token: tokenData.accessToken,
      }).then((resp) => {
        if (resp.status === 200) {
          Sentry.captureEvent({ message: `Inhouse Request ${data.topicId}`, level: 'info' })
          if (!import.meta.env.DEV) {
            Redirect('../erfolg')
          }
        }
      })
    })
  }
  const confirmCancelAction = () => {
    dialogObj.hide()

  }

  return (
    <div className={'bg2'}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            {topic && (
              <>
                <div className={styles.formGrid} style={{ display: 'flex', flexDirection: 'column' }}>
                  <div>Thema</div>
                  <div>
                    <a className="lead" id="thmLead" href={`${window.location.origin}${topic?.seminarLink}`}>
                      {topic?.thmLang}
                    </a>
                  </div>
                </div>
              </>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className={styles.formGrid}>
              <header className={styles.header}>Seminar Details</header>
              <div className={styles.formRow}>
                <label htmlFor="themenwunsch">
                  {topic === null ? (
                    <>
                      Themenwunsch <br /> (oder Seminarcode) *:
                    </>
                  ) : (
                    <>Thema:</>
                  )}
                </label>
                <div>
                  <TextBoxComponent {...register('themenwunsch', { required: true })} type="text" id="themenwunsch"
                                    readOnly={topic !== null} />
                  {errors.themenwunsch && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>
              <div className={styles.formRow}>
                <label htmlFor="zielgruppe">Zielgruppe:</label>
                <TextBoxComponent {...register('zielgruppe', { required: false })} type="text" id="zielgruppe" />
                {errors.zielgruppe && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>
              <div className={styles.formRow}>
                <label htmlFor="vOrt">Veranstaltungsort:</label>
                <TextBoxComponent {...register('veranstaltungsort', { required: false })} type="text" id="vOrt" />
                {errors.veranstaltungsort && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>
              <div className={styles.formRow}>
                <label htmlFor="termin">Terminwunsch:</label>
                <TextBoxComponent {...register('terminwunsch', { required: false })} type="text" id="termin" />
                {errors.terminwunsch && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>
              <div className={styles.formRow}>
                <label htmlFor="dauer">Seminardauer (Tage):</label>
                <TextBoxComponent {...register('seminarDauer', { required: false })} type="text" id="dauer"
                                  readOnly={topic !== null} />
                {errors.seminarDauer && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>
              {topic === null ? (<div className={styles.formRow}>
                <label htmlFor="anzahl">Teilnehmeranzahl *:</label>
                <div>
                  <TextBoxComponent
                    {...register('teilnehmeranzahl', {
                      required: true,
                    })}
                    type="text"
                    id="anzahl"
                  />
                  {errors.teilnehmeranzahl && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>) : (<>
                <div className={styles.formRow}>
                  <div style={{ fontSize: '16px', textAlign: 'end', alignSelf: 'self-end' }}>
                    <label>Anzahl Teilnehmer:</label>
                  </div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 'bolder', alignItems: 'center' }}><p
                      className={styles.optionLabelChoice}>
                      Bei Auswahl der Optionen „5-10 Teilnehmer“ oder „11-15 Teilnehmer“ erhalten Sie eine
                      Preisauskunft per E-Mail,<br />
                      wenn Sie beim Absenden des Formulars den Button „Preisinformation“ anklicken.
                    </p>
                    </div>
                    <Controller
                      control={control}
                      name="plannedParticipants"
                      rules={{ required: 'Bitte wählen Sie eine Anzahl aus.' }}
                      render={({ field }) => (
                        <>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <RadioButtonComponent name={field.name} label="5-10" labelPosition={'After'} value={'0'}
                                                  checked={field.value === 0} change={(e: ChangeEventArgs) => {
                              field.onChange(Number(e.value))
                            }} cssClass={styles.customRadioLabel} />
                            <RadioButtonComponent name={field.name} label="11-15"
                                                  labelPosition={'After'} value={'1'}
                                                  checked={field.value === 1} change={(e: ChangeEventArgs) => {
                              field.onChange(Number(e.value))
                            }} cssClass={styles.customRadioLabel} />
                            <RadioButtonComponent name={field.name} label="16-20" labelPosition={'After'} value={'2'}
                                                  checked={field.value === 2} change={(e: ChangeEventArgs) => {
                              field.onChange(Number(e.value))
                            }} />
                            <RadioButtonComponent name={field.name} label="21-25" labelPosition={'After'} value={'3'}
                                                  checked={field.value === 3} change={(e: ChangeEventArgs) => {
                              field.onChange(Number(e.value))
                            }} />
                            <RadioButtonComponent name={field.name} label="> 25" labelPosition={'After'} value={'4'}
                                                  checked={field.value === 4} change={(e: ChangeEventArgs) => {
                              field.onChange(Number(e.value))
                            }} />
                            {radio === 4 &&
                              <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}>
                                <div style={{ width: '100px' }}>
                                  <TextBoxComponent enabled={radio === 4}   {...register('teilnehmeranzahl', {
                                    required: radio === 4,
                                  })}
                                                    type="text"
                                                    id="anzahl" />
                                </div>
                                <label>Teilnehmer</label>
                              </div>

                            }
                            {errors.teilnehmeranzahl &&
                              <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                          </div>
                        </>
                      )}
                    />
                  </div>

                </div>

              </>)}


              {cleanHtmlContent && (
                <div className={styles.formRow}>
                  <label>Geplante Inhalte:</label>
                  <div dangerouslySetInnerHTML={{ __html: cleanHtmlContent }} />
                </div>
              )}

              <div className={styles.formRow}>
                <label>Bemerkungen:</label>
                <Controller
                  control={control}
                  name="bemerkungen"
                  render={({ field }) => (
                    <>
                      <RichTextEditorComponent
                        locale={'de'}
                        fontFamily={{ default: 'Arial' }}
                        value={field.value}
                        change={(e: ChangeEventArgs) => field.onChange(e.value)}
                        id="bemerkungen"
                        toolbarSettings={toolbarSettings}
                        height="247px"
                        saveInterval={1}
                        showCharCount={true}
                        maxLength={5000}
                      >
                        <Inject
                          services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar, Table, Count, PasteCleanup, FormatPainter]} />
                      </RichTextEditorComponent>
                    </>
                  )}
                />
                {errors.bemerkungen && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>

              <div className={styles.formRow}>
                <label>Durchführungsform*:</label>
                <div>
                  <Controller
                    control={control}
                    name="teilnahmeForm"
                    defaultValue={1}
                    rules={{ required: 'Bitte wählen Sie Sie eine Teilnahmeform aus.' }}
                    render={({ field }) => (
                      <>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <CheckBoxComponent id="onlineOption" label="Online-Veranstaltung" labelPosition={'After'}
                                             disabled={topic !== null && (topic.thmTypValue === 'Präsenz' || topic.thmTypValue === 'Online')}
                                             checked={field.value === 0} change={() => handleChange('online')} />
                          <CheckBoxComponent id="praesenzOption" label="Präsenz-Veranstaltung" labelPosition={'After'}
                                             disabled={topic !== null && (topic.thmTypValue === 'Präsenz' || topic.thmTypValue === 'Online')}
                                             checked={field.value === 1} change={() => handleChange('praesenz')} />
                        </div>
                      </>
                    )}
                  />
                </div>
                {errors.teilnahmeForm && <span className={styles.error}>Bitte wähle eine Option.</span>}
              </div>

              <header className={styles.header}>Kundenangaben</header>
              <div className={styles.formRow}>
                <label htmlFor="kundenNr">Kunden-Nr.</label>
                <TextBoxComponent {...register('kundenNr', { required: false })} type="text" id="kundenNr" />
                {errors.kundenNr && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>
              <div className={styles.formRow}>
                <label htmlFor="oAp">organisatorischer Ansprechpartner/in *:</label>
                <div>
                  <TextBoxComponent {...register('organisatorischerAnsprechpartner', { required: true })} type="text"
                                    id="oAp" />
                  {errors.organisatorischerAnsprechpartner &&
                    <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>
              <div className={styles.formRow}>
                <label htmlFor="iAp">inhaltlicher Ansprechpartner/in:</label>
                <TextBoxComponent {...register('inhaltlicherAnsprechpartner', { required: false })} type="text"
                                  id="iAp" />
                {errors.inhaltlicherAnsprechpartner &&
                  <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>
              <div className={styles.formRow}>
                <label htmlFor="firma">Firma *:</label>
                <div>
                  <TextBoxComponent {...register('firma', { required: true })} type="text" id="firma" />
                  {errors.firma && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>
              <div className={styles.formRow}>
                <label htmlFor="abteilung">Abteilung:</label>
                <TextBoxComponent {...register('abteilung', { required: false })} type="text" id="abteilung" />
                {errors.abteilung && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
              </div>
              <div className={styles.formRow}>
                <label htmlFor="strasse">Straße *:</label>
                <div>
                  <TextBoxComponent {...register('strasse', { required: true })} type="text" id="strasse" />
                  {errors.strasse && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>
              <div className={styles.formRow}>
                <label htmlFor="postleitzahl">Postleitzahl *:</label>{' '}
                <div>
                  <TextBoxComponent {...register('postleitzahl', { required: true })} type="text" id="postleitzahl" />
                  {errors.postleitzahl && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>
              <div className={styles.formRow}>
                <label htmlFor="ort">Ort *:</label>
                <div>
                  <TextBoxComponent {...register('ort', { required: true })} type="text" id="ort" />
                  {errors.ort && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>
              <div className={styles.formRow}>
                <label htmlFor="telefon">Telefon *:</label>
                <div>
                  <TextBoxComponent {...register('telefon', { required: true })} type="text" id="telefon" />
                  {errors.telefon && <span className={styles.error}>Dieses Feld ist erforderlich.</span>}
                </div>
              </div>

              <div className={styles.formRow}>
                <label htmlFor="email">E-Mail*:</label>
                <div>
                  <TextBoxComponent
                    {...register('email', {
                      required: 'E-Mail ist erforderlich',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Ungültige E-Mail-Adresse',
                      },
                    })}
                    id="email"
                  />
                  {errors.email && <span className={styles.error}>{errors.email.message}</span>}
                </div>
              </div>
              <div className={styles.submitButton} style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
                {(radio === 0 || radio === 1) &&
                  <div className={styles.submitButton}>
                    <ButtonComponent type={'button'} isPrimary onClick={buttonClick}>PREISINFORMATION</ButtonComponent>
                  </div>
                }
                <div className={styles.submitButton}>
                  <ButtonComponent type={'submit'} isPrimary>ANGEBOT ANFORDERN</ButtonComponent>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InhouseRequest
